import { OrderListBuilder } from "../class/OrderListBuilder";
import { Bot, OrderBuildSteps } from "../_app/types";
import { _roundDec, _roundToDecimals } from "./_roundToDecimals";
import { precision } from "./_precision";
import { AppDispatch } from "../store/store";

export function _createOrdersInvestmentStep(
  bot: Bot,
  orderStep: number,
  priceStepQuery: number,
  dispatch?: AppDispatch
): OrderBuildSteps {
  // precision(priceStepQuery) === precision(bot.ticker.priceStep)
  const orderListBuilder = new OrderListBuilder(
    bot.gridType,
    orderStep,
    bot.gridDirection,
    _roundDec(bot.priceStep, bot.gridType === "ARITHMETIC" ? precision(bot.ticker.priceStep) : 4),
    bot.startPrice,
    bot.gridsAmount,
    precision(priceStepQuery)
  );

  const orders = orderListBuilder.createOrders();

  // Группировка и вычисление investmentStepInBase
  // 	const investmentStepInBase = Math.max(...Object.values(
  // 		orders.reduce((groups, order) => {
  // 			if (!groups[order.orderSide]) {
  // 				groups[order.orderSide] = 0;
  // 			}
  // 			groups[order.orderSide] += order.amount;
  // 			return groups;
  // 		}, {} as Record<string, number>)
  // 	));

  const investmentStepInBase = orders.reduce((sum, order) => {
    return sum + order.amount;
  }, 0);

  // console.log(investmentStepInBase);
  console.log(+investmentStepInBase.toFixed(Math.abs(Math.log10(priceStepQuery))));
  // console.log(Math.abs(Math.log10(priceStepQuery)));

  // const investmentStepInQuote = Math.max(...Object.values(
  // 	orders.reduce((groups, order) => {
  // 		if (!groups[order.orderSide]) {
  // 			groups[order.orderSide] = 0;
  // 		}
  // 		groups[order.orderSide] += order.amount * order.openPrice;
  // 		return groups;
  // 	}, {} as Record<string, number>)
  // ));

  const investmentStepInQuote = orders.reduce((sum, order) => {
    return sum + order.amount * order.openPrice;
  }, 0);

  console.log(_roundToDecimals(investmentStepInQuote, Math.abs(Math.log10(priceStepQuery))));

  console.log(orders);

  return {
    orders: orders,
    stepInBase: _roundToDecimals(investmentStepInBase, Math.abs(Math.log10(orderStep))),
    stepInQuote: _roundToDecimals(investmentStepInQuote, Math.abs(Math.log10(priceStepQuery))),
  };
}
